<button
  [disabled]="disabled"
  [class.disabled]="disabled"
  [class.has-error]="hasError"
  (click)="onSummaryClick()"
  class="filter-summary-button tooltip-container"
>
  <span class="filter-summary-label tooltip-container">
    @if (isValueEmpty) {
      <span class="name">{{ filterName | translate }}</span>
    } @else {
      <span class="name">{{ filterName | translate }}:</span> {{ summary }}
    }
    <nimbus-tooltip [text]="summary"></nimbus-tooltip>
  </span>

  @if (isValueEmpty) {
    <span class="filter-summary-remove" [nimbusIcon]="ICONS.CHEVRON_DOWN"></span>
  } @else {
    <span class="filter-summary-remove" [nimbusIcon]="ICONS.CLOSE" (click)="onRemoveFilter($event)"></span>
  }
</button>
